import manifest from "./manifest.json";

const config = {
	...manifest.project,
	...manifest.data
};

export const { title, frame, palette, api, version, districtMode } = config;

export default config;
